import { render, staticRenderFns } from "./AllTicketsInbox.vue?vue&type=template&id=778d359b&scoped=true&"
import script from "./AllTicketsInbox.vue?vue&type=script&lang=ts&"
export * from "./AllTicketsInbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d359b",
  null
  
)

export default component.exports